// Lightweight helpers to work with Home Assistant entities in Redux state

// Get an entity object by id from the Redux root state
export const getEntityById = (state, entityId) => {
  return (state && state.hassio && state.hassio.entities && state.hassio.entities[entityId]) || null;
};

// Extract friendly name or fall back to the entity_id
export const getFriendlyName = (entity, fallbackId) => {
  return (entity && entity.attributes && entity.attributes.friendly_name) || fallbackId;
};

// Normalize raw state string
export const getRawState = (entity) => {
  return entity && typeof entity.state === 'string' ? entity.state : 'unknown';
};

// Localize state values (currently supports Dutch for on/off)
export const localizeState = (stateValue, locale = 'en') => {
  if (locale === 'nl') {
    if (stateValue === 'on') return 'aan';
    if (stateValue === 'off') return 'uit';
    if (stateValue === 'unknown') return 'onbekend';
  }
  return stateValue;
};

// Convenience boolean
export const isOn = (entity) => getRawState(entity) === 'on';

// One-call helper to grab key info
export const getEntityInfo = (state, entityId, options = {}) => {
  const locale = options.locale || 'en';
  const entity = getEntityById(state, entityId);
  const stateValue = getRawState(entity);
  const name = getFriendlyName(entity, entityId);
  return {
    entity,
    entityId,
    name,
    state: stateValue,
    stateLocalized: localizeState(stateValue, locale),
    isOn: stateValue === 'on',
  };
};

// Flexible "night mode" evaluator that can evolve later
// Usage: isNightMode(state) // default rule: light.spot_boxes === 'off'
//        isNightMode(state, { rules: [{ entityId: 'light.living_room', equals: 'off' }], combiner: 'any' })
export const isNightMode = (state, config = {}) => {
  const rules = config.rules || [
    { entityId: 'light.spot_boxes', equals: 'off' },
    { entityId: 'light.kitchen_spot', equals: 'off' },
  ];
  const combiner = config.combiner || 'all'; // 'all' | 'any'

  const evaluateRule = (rule) => {
    if (!rule || !rule.entityId) return false;
    const entity = getEntityById(state, rule.entityId);
    const current = getRawState(entity);
    if (rule.equals !== undefined) return current === rule.equals;
    if (rule.notEquals !== undefined) return current !== rule.notEquals;
    if (Array.isArray(rule.in)) return rule.in.includes(current);
    if (typeof rule.matcher === 'function') return !!rule.matcher(current, entity, state);
    return false;
  };

  const results = rules.map(evaluateRule);
  return combiner === 'any' ? results.some(Boolean) : results.every(Boolean);
};



